<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="제품소개" tabActive="제로장" bg="/images/sub/about/visual.jpg">
                <template #title>{{ $t("제품소개") }}</template>
            </sub-head-primary>
        </template>

        <page-section-primary class="page-section--first page-section--last">
            <sub-product-info num="01" name="제로장" tag="zeroZang.tag">
                <template #txt>
                    <span v-html="$t('zeroZang.txt2')" />
                </template>
            </sub-product-info>

            <v-img max-width="1000" class="ma-auto" src="/images/sub/product/zero-zang/detail.jpg" />

            <!-- <u-tit-wrap-default class="tit-wrap--sm">
                <u-tit-default class="tit--xxs">식품정보</u-tit-default>
            </u-tit-wrap-default>
            <div class="v-data-table v-data-table--line v-data-table--border">
                <div class="v-data-table__wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th-primary class="w-25">검사항목</th-primary>
                                <th-primary class="w-25">단위</th-primary>
                                <th-primary class="w-25">시험결과 (100g(ml) 기준)</th-primary>
                                <th-primary class="w-25" colspan="2">1일 영양성분 기준치에대한 비율(%)</th-primary>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td-primary>열량</td-primary>
                                <td-primary>Kcal/100g</td-primary>
                                <td-primary>154.24</td-primary>
                                <td-primary class="w-125">-</td-primary>
                                <td-primary class="w-125">-</td-primary>
                            </tr>
                            <tr>
                                <td-primary>탄수화물</td-primary>
                                <td-primary>g/100g</td-primary>
                                <td-primary>33.19</td-primary>
                                <td-primary class="w-125">10.2</td-primary>
                                <td-primary class="w-125">10</td-primary>
                            </tr>
                            <tr>
                                <td-primary>당류</td-primary>
                                <td-primary>g/100g</td-primary>
                                <td-primary>2.60</td-primary>
                                <td-primary class="w-125">2.6</td-primary>
                                <td-primary class="w-125">3</td-primary>
                            </tr>
                            <tr>
                                <td-primary>조단백질</td-primary>
                                <td-primary>g/100g</td-primary>
                                <td-primary>2.85</td-primary>
                                <td-primary class="w-125">5.1</td-primary>
                                <td-primary class="w-125">5</td-primary>
                            </tr>
                            <tr>
                                <td-primary>조지방</td-primary>
                                <td-primary>g/100g</td-primary>
                                <td-primary>1.12</td-primary>
                                <td-primary class="w-125">2.0</td-primary>
                                <td-primary class="w-125">2</td-primary>
                            </tr>
                            <tr>
                                <td-primary>포화지방</td-primary>
                                <td-primary>g/100g</td-primary>
                                <td-primary>0.28</td-primary>
                                <td-primary class="w-125">1.8</td-primary>
                                <td-primary class="w-125">2</td-primary>
                            </tr>
                            <tr>
                                <td-primary>트랜스지방</td-primary>
                                <td-primary>g/100g</td-primary>
                                <td-primary>0.00</td-primary>
                                <td-primary class="w-125">-</td-primary>
                                <td-primary class="w-125">-</td-primary>
                            </tr>
                            <tr>
                                <td-primary>콜레스테롤</td-primary>
                                <td-primary>mg/100g</td-primary>
                                <td-primary>0.00</td-primary>
                                <td-primary class="w-125">0.0</td-primary>
                                <td-primary class="w-125">0</td-primary>
                            </tr>
                            <tr>
                                <td-primary>나트륨</td-primary>
                                <td-primary>mg/100g</td-primary>
                                <td-primary>1,708.46</td-primary>
                                <td-primary class="w-125">85.4</td-primary>
                                <td-primary class="w-125">85</td-primary>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div> -->
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import PageSectionSecondary from "@/sets/parents/pages/page-section-secondary.vue";
import BtnPrimary from "@/components/publish/parents/buttons/btn-primary.vue";

import UTitWrapDefault from "@/components/publish/styles/typography/u-tit-wrap-default.vue";
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";
import ThPrimary from "@/components/publish/parents/tables/th-primary.vue";
import TdPrimary from "@/components/publish/parents/tables/td-primary.vue";

import SubProductInfo from "@/components/client/sub/sub-product-info.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        PageSectionSecondary,
        BtnPrimary,

        UTitWrapDefault,
        UTitDefault,
        ThPrimary,
        TdPrimary,

        SubProductInfo,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
